import {Component, inject, signal} from '@angular/core';

import {ConsentBannerComponent} from "@selpia/shared/ui";
import {CookieConsentService} from '../services/cookie-consent.service';

@Component({
  selector: 'lib-feature-consent',
  imports: [ConsentBannerComponent],
  templateUrl: './feature-consent.component.html',
  styleUrl: './feature-consent.component.scss',
})
export class FeatureConsentComponent {
  protected readonly cookieConsentService = inject(CookieConsentService);

  protected readonly isVisible = signal(true);

  handleConsent() {
    this.cookieConsentService.updateConsent();
  }

  handleDenial() {
    this.isVisible.set(false);
  }
}
